// --- Configuración de Autenticación con Azure AD ---
const API_URL = process.env.REACT_APP_API_URL || '/api';

export const authConfig = {
    loginUrl: `${API_URL}/auth/azure`,
    logoutUrl: `${API_URL}/auth/logout`
};

// --- API FUNCTIONS (Funciones de Interacción con la API) ---

// Inicia el proceso de login redirigiendo al backend
export const loginWithAzure = () => {
    window.location.href = authConfig.loginUrl;
};

// Verifica si hay un token en la URL (al volver del login) y lo guarda
export const handleAuthCallback = () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    if (token) {
        localStorage.setItem('token', token);
        // Limpia la URL para no dejar el token visible
        window.history.replaceState({}, document.title, window.location.pathname);
        return token;
    }
    return null;
};

// Cierra la sesión, eliminando el token del localStorage
export const logout = () => {
localStorage.removeItem('token');
// Opcional: Podrías redirigir al usuario a la página de logout del backend o a la página de inicio
// window.location.href = authConfig.logoutUrl;
};
